import { useTranslation } from 'react-i18next';

/** Read-only transcript views load one bounded window; say so when the chat is longer than it. */
function RecentPartNotice({ chat }: { chat?: { partCount?: number; parts?: unknown[] } | null }) {
  const { t } = useTranslation('chat');

  if (!chat?.partCount || chat.partCount <= (chat.parts?.length ?? 0)) {
    return null;
  }

  return <p className="text-sm text-gray-500 text-center mb-4">{t('controls.showing-recent-part')}</p>;
}

export default RecentPartNotice;
